// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__WWHQR","messages":"Chat_messages__zMnwR","dateDivider":"Chat_dateDivider__deoa_"};